import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const newItem = {
  id: 0,
  severity: 0,
  expression: null,
  message: null,
  latinMessage: null
}

const initialState = {
  checkingRule: null,
  fetching: false,
  updating: false,
  componentKey: getComponentKey(),
  gridKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'checkingRules/fetching',
  fetched: 'checkingRules/fetched',
  updating: 'checkingRules/updating',
  updated: 'checkingRules/updated',
  deleted: 'checkingRules/deleted',
  error: 'checkingRules/error'
}

export const actionCreators = {

  get: (id) => (dispatch) => {
    if (id > 0) {
      dispatch({ type: actionTypes.fetching })
      context.api.checkingRuleService.get(id, allowErrorDialog)
        .then(response => {
          dispatch({ type: actionTypes.fetched, data: response })
        })
        .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
    } else {
      dispatch({ type: actionTypes.fetched, data: { ...newItem } })
    }
  },
  save: (input, callback) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.checkingRuleService.save(input, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.updated })
        if (typeof callback === 'function') { callback() }
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  },
  delete: (id, callback) => (dispatch) => {
    context.api.checkingRuleService.delete(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.deleted })
      })
      .catch(() => dispatch({ type: actionTypes.error }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, checkingRule: action.data, componentKey: getComponentKey() }
    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false, componentKey: getComponentKey(), gridKey: getComponentKey() }
    case actionTypes.deleted: return { ...state, gridKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/checkingRules.js